import { Component, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/shared/models';

@Component({
    selector: 'app-project-equipment-setup',
    templateUrl: './equipment-setup.component.html',
    styleUrls: ['./equipment-setup.component.scss'],
    standalone: false
})
export class EquipmentSetupComponent implements OnInit {

  @Input() project: Project;
  constructor() { }

  ngOnInit(): void {
  }

}
